import styled from "styled-components";

export const FilterItem = styled.div<{ selected?: boolean }>`
  display: flex;
  flex: 1 0;
  width: 33.33%;
  flex-direction: column;
  cursor: pointer;
  padding: 15px 10px 10px 10px;
  &:not(:last-child) {
    border-right: 0.5px solid ${(props) => props.theme.sepColor};
  }
  border-bottom: 0.5px solid ${(props) => props.theme.sepColor};
  background-color: ${(props) =>
    props.selected ? props.theme.smalt : props.theme.white};
  color: ${(props) => (props.selected ? props.theme.white : props.theme.black)};

  b {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const FilterItemTitle = styled.div`
  font-size: 10px;
`;

export const FilterItemData = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FilterItemArrow = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  transform: ${(props) => (props.selected ? "rotate(180deg)" : null)};
`;
